import { Button } from '@saay/shadcn/components/button';
import { Empty, EmptyContent, EmptyHeader, EmptyTitle } from '@saay/shadcn/components/empty';
import { Skeleton } from '@saay/shadcn/components/skeleton';
import { type ReactNode } from 'react';

/** Empty list: the title is a heading, matching the state-matrix queries. */
export function ListEmpty({
  action,
  title,
}: {
  readonly action?: ReactNode;
  readonly title: string;
}) {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyTitle>
          <h2>{title}</h2>
        </EmptyTitle>
      </EmptyHeader>
      {action === undefined ? null : <EmptyContent>{action}</EmptyContent>}
    </Empty>
  );
}

export function ListSkeleton({
  label,
  lines = 6,
}: {
  readonly label: string;
  readonly lines?: number;
}) {
  return (
    <div aria-busy="true" aria-live="polite" className="flex flex-col gap-2" role="status">
      <span className="sr-only">{label}</span>
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton className="h-8 w-full" key={index} />
      ))}
    </div>
  );
}

export function ClearFiltersButton({ onClick }: { readonly onClick: () => void }) {
  return (
    <Button onClick={onClick} type="button" variant="outline">
      پاک‌کردن فیلترها
    </Button>
  );
}
